import React from 'react';
import VerifyCode from "../../../Code/VerifyCode";
import PasswordForm from "../../../Login/PasswordForm";

class CompleteLoginView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ...props,
        };
    }

    render() {
        return (
            <>
                {this.props.showForm === "PASSWORD" ?
                    <PasswordForm
                        style={this.props.style}
                        username={this.props.username}
                        savePayload={this.props.savePayload}
                        payload={this.props.payload}
                        signInType={this.props.signInType}
                        displayForm={this.props.displayForm}
                        showForm={this.props.showForm}
                        saveStep={this.props.saveStep}
                    />
                    :
                    <VerifyCode style={this.props.style}
                        finishAuth={true}
                        signInType={this.props.signInType}
                        payload={this.props.payload}
                        savePayload={this.props.savePayload}
                        saveCode={this.props.saveCode}
                        displayForm={this.props.displayForm}
                        showForm={this.props.showForm}
                        saveStep={this.props.saveStep}
                    />
                }
            </>
        );
    }
}

export default CompleteLoginView;